import { Segmentado, type OpcaoSegmentada } from '@/componentes/segmentado';
import { Valor } from '@/componentes/valor';
import type { ChaveMes } from '@/dados';

import { COBERTURAS, coberturaOferecida, type Cobertura } from './cobertura';
import { Fechamento } from './fechamento';
import { Grade } from './grade';
import type { LinhaMes } from './meses';
import type { ResumoHistorico } from './resumo';

/* O histórico mês a mês, que é como o volume é informado.
   Grava em `integradores.sazonalidade` {meses, cobertura}.

   A cobertura vem PRIMEIRO e sem valor marcado, então a grade só aparece
   depois da escolha: são os meses informados que o motor anualiza, e uma
   grade aberta por conta própria convidaria a preencher doze linhas sob uma
   premissa que ninguém declarou. */

const OPCOES: ReadonlyArray<OpcaoSegmentada<string>> = COBERTURAS.map((n) => ({
  valor: String(n),
  rotulo: String(n),
  descricao: `${n} meses`,
}));

export function Historico({
  cobertura,
  aoMudarCobertura,
  meses,
  aoMudarMes,
  resumo,
  mediaGravada,
}: {
  cobertura: Cobertura | null;
  aoMudarCobertura: (cobertura: Cobertura) => void;
  meses: Record<ChaveMes, LinhaMes>;
  aoMudarMes: (chave: ChaveMes, linha: LinhaMes) => void;
  resumo: ResumoHistorico;
  /** Média por mês gravada antes de a tela deixar de oferecer o campo. */
  mediaGravada: number | null;
}) {
  function mudarCobertura(escolha: string) {
    const escolhida = coberturaOferecida(escolha);
    if (escolhida !== null) aoMudarCobertura(escolhida);
  }

  return (
    <div className="grid gap-5">
      <div className="grid gap-2">
        <Segmentado
          opcoes={OPCOES}
          valor={cobertura === null ? null : String(cobertura)}
          aoMudar={mudarCobertura}
          nome="cobertura"
          tamanho="pequeno"
          rotulo="Quantos meses de histórico você tem"
        />
        <p className="apoio-nota">
          {cobertura === null
            ? 'Escolha a quantidade de meses para abrir o preenchimento.'
            : 'Preencha só os meses que você tem. Com menos de 12, o sistema projeta o ano inteiro a partir deles.'}
        </p>
      </div>

      {cobertura === null ? null : (
        <>
          <Grade
            chaves={resumo.chavesAtivas}
            cobertura={cobertura}
            meses={meses}
            aoMudarMes={aoMudarMes}
          />
          <Fechamento cobertura={cobertura} resumo={resumo} />

          {mediaGravada !== null ? (
            <p className="apoio-nota">
              Há uma média de <Valor valor={mediaGravada} formato="numero" /> projetos por mês
              gravada. Salvar substitui esse número pelo histórico.
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
